import { render, staticRenderFns } from "./HorizontalStepperLabel.vue?vue&type=template&id=74b0b0d6&scoped=true&lang=pug"
import script from "./HorizontalStepperLabel.vue?vue&type=script&lang=ts"
export * from "./HorizontalStepperLabel.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalStepperLabel.vue?vue&type=style&index=0&id=74b0b0d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0b0d6",
  null
  
)

export default component.exports